<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="items.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div>
          <div v-html="formatCount">
          </div>
          <div v-html="formatSumArrears">
          </div>
          <div v-html="formatSumTotals">
          </div>
        </div>
        <div>
        </div>
      </div>
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show = "items.length > 0 && overallCount > 20">
        <b>ВАЖНО!</b> Показываются только 20 задолжностей в порядке убывания суммы текущего долга.<br/><br/>
      </div>

      <div v-show = "isLoaded">

        <template v-for="item in lowItems">
          <div>
            <div>
              <b>
              {{item.tax}} за {{item.period}} г.
              </b>
            </div>
            <v-flex pl-2>
              <div>Задолженность/пени/штрафы/всего: {{formatCurrency(item.arrear)}} / {{formatCurrency(item.penalty)}} / {{formatCurrency(item.forFeit)}} / <b>{{formatCurrency(item.total)}}</b>
              </div>
            </v-flex>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-arrears-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      overallCount: null,
      sumArrear: null,
      sumPenalty: null,
      sumForFeit: null,
      sumTotal: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderDateSince: 'renderDateSince'
      }),
      lowItems () {
        return this.items.slice(0, 20)
      },
      formatCount () {
        return ''.concat(
          'Задолженностей и недоимок всего ',
          this.overallCount ? this.overallCount : 0
          )
      },
      formatSumArrears () {
        if (this.sumArrear === null) {
          return ''
        }
        return ''.concat(
          'Сумма задолженностей ',
          this.formatCurrency(this.sumArrear)
          )
      },
      formatSumTotals () {
        if (this.sumTotal === null) {
          return ''
        }
        return ''.concat(
          'Задолженностей и недоимок всего ',
          this.formatCurrency(this.sumTotal)
          )
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' р.' : ''
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о суммах недоимок и задолженностей по пеням и штрафам '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/arrears',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.overallCount = null
          this.sumArrear = null
          this.sumPenalty = null
          this.sumForFeit = null
          this.sumTotal = null
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.isLoading = false
            this.items = data.items
            this.overallCount = data.count
            this.sumArrear = data.sumArrear
            this.sumPenalty = data.sumPenalty
            this.sumForFeit = data.sumForFeit
            this.sumTotal = data.sumTotal
          })
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ArrearsPanel.vue?ecc8744e